function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState, useEffect, useRef } from 'react';
import { push as Menu } from 'react-burger-menu';
import { prefixLink } from '../../../../utils';
import MultiLevelMenu from "../multi-level-menu/index";
import Logo from '../../shared/Logo';
import { MobileNavigationStyles } from './MobileNavigationStyles';
import { HeaderNavigationStyles } from './HeaderNavigationStyles';
export default function MobileNavigation(_ref) {
  var appProps = _ref.appProps,
    navigation = _ref.navigation;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    menuOpen = _useState2[0],
    setMenuOpen = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    navigationState = _useState4[0],
    setNavigationState = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    showMenuItem = _useState6[0],
    setShowMenuItem = _useState6[1];
  var _useState7 = useState({}),
    _useState8 = _slicedToArray(_useState7, 2),
    showSubmenuItem = _useState8[0],
    setShowSubmenuItem = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    burgerButtonPosition = _useState10[0],
    setBurgerButtonPosition = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    burgerButtonHeight = _useState12[0],
    setBurgerButtonHeight = _useState12[1];
  var navRef = useRef(null);
  var frontendStyles = appProps.frontendStyles;
  var currentPath = window.location.pathname;
  useEffect(function () {
    setInterval(function () {
      if (appProps.headerVersion == '6') {
        if (document.getElementsByClassName('top_header')[0] != undefined) {
          var topHeaderHeight = document.getElementsByClassName('top_header')[0].offsetHeight;
          var logoWrapperHeight = document.getElementsByClassName('logo_wrapper')[0].offsetHeight;
          setBurgerButtonPosition(topHeaderHeight);
          setBurgerButtonHeight(topHeaderHeight + (logoWrapperHeight - 10));
        } else if (document.getElementsByClassName('header_wrapper')[0] != undefined) {
          var _logoWrapperHeight = document.getElementsByClassName('logo_wrapper')[0].offsetHeight;
          // We are adding 20px extra from top since the total padding of the header is 40px.
          // So we are adding 20px from the top to align based on the logo height
          setBurgerButtonPosition(20);
          setBurgerButtonHeight(_logoWrapperHeight);
        }
      } else {
        if (document.getElementsByClassName('top_header')[0] != undefined) {
          var _topHeaderHeight = document.getElementsByClassName('top_header')[0].offsetHeight;
          var headerWrapperHeight = document.getElementsByClassName('header_wrapper')[0].offsetHeight;
          setBurgerButtonHeight(headerWrapperHeight + _topHeaderHeight);
          setBurgerButtonPosition(_topHeaderHeight / 2);
        } else if (document.getElementsByClassName('header_wrapper')[0] != undefined) {
          var _headerWrapperHeight = document.getElementsByClassName('header_wrapper')[0].offsetHeight;
          setBurgerButtonHeight(_headerWrapperHeight);
        } else {
          setBurgerButtonHeight(appProps.frontendStyles.headerNavigation.headerHeight);
        }
      }
    }, 500);
  }, []);
  var burgerStyles = {
    bmBurgerButton: {
      position: 'absolute',
      left: '15px',
      height: burgerButtonHeight ? "".concat(burgerButtonHeight, "px") : 'auto',
      top: burgerButtonPosition ? "".concat(burgerButtonPosition, "px") : 'auto'
    }
  };
  function handleStateChange(state) {
    setMenuOpen(state.isOpen);
  }
  function closeMenu() {
    setMenuOpen(false);
  }
  function toggleMenu() {
    setMenuOpen(function (prevState) {
      return !prevState;
    });
  }
  function recursion(nav) {
    return nav.children.map(function (child) {
      var _child$translations$f;
      return {
        value: ((_child$translations$f = child.translations.find(function (c) {
          return c.locale === appProps.currentLocale;
        })) === null || _child$translations$f === void 0 ? void 0 : _child$translations$f.title) || '',
        link: prefixLink(child, appProps),
        items: recursion(child)
      };
    });
  }
  var menuItems = navigation.items.map(function (nav) {
    var _nav$translations$fin;
    return {
      value: ((_nav$translations$fin = nav.translations.find(function (n) {
        return n.locale === appProps.currentLocale;
      })) === null || _nav$translations$fin === void 0 ? void 0 : _nav$translations$fin.title) || '',
      link: prefixLink(nav, appProps),
      items: recursion(nav)
    };
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "mobile-navigation-wrapper"
  }, menuOpen && /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      top: 20,
      zIndex: 9999
    }
  }, appProps.preferences.logo ? /*#__PURE__*/React.createElement(Logo, {
    appProps: appProps,
    target: '_self',
    logo: appProps.preferences.logo
  }) : /*#__PURE__*/React.createElement("div", {
    className: "site-name-logo"
  }, /*#__PURE__*/React.createElement("a", {
    href: appProps.rootPath,
    rel: "nofollow noindex"
  }, appProps.preferences.site_name ? appProps.preferences.site_name : ''))), /*#__PURE__*/React.createElement(Menu, {
    isOpen: menuOpen,
    styles: burgerStyles,
    pageWrapId: "page-wrap",
    outerContainerId: "outer-container",
    className: "multi-level-menu-wrapper",
    onStateChange: function onStateChange(state) {
      return handleStateChange(state);
    },
    customBurgerIcon: /*#__PURE__*/React.createElement("i", {
      className: "fa-light fa-bars"
    }),
    customCrossIcon: /*#__PURE__*/React.createElement("i", {
      className: "fa-light fa-xmark"
    }),
    noOverlay: appProps.headerVersion == '4'
  }, /*#__PURE__*/React.createElement(MultiLevelMenu, {
    appProps: appProps,
    items: menuItems,
    frontendStyles: frontendStyles
  })));
}